var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighPrority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.0576L9.53252 6.87761C9.4628 6.80731 9.37985 6.75152 9.28846 6.71344C9.19706 6.67537 9.09903 6.65576 9.00002 6.65576C8.90101 6.65576 8.80298 6.67537 8.71159 6.71344C8.6202 6.75152 8.53724 6.80731 8.46752 6.87761L5.28752 10.0576C5.21723 10.1273 5.16143 10.2103 5.12335 10.3017C5.08528 10.3931 5.06567 10.4911 5.06567 10.5901C5.06567 10.6891 5.08528 10.7871 5.12335 10.8785C5.16143 10.9699 5.21723 11.0529 5.28752 11.1226C5.42804 11.2623 5.61813 11.3407 5.81627 11.3407C6.01441 11.3407 6.2045 11.2623 6.34502 11.1226L9.00002 8.46761L11.655 11.1226C11.7947 11.2612 11.9833 11.3393 12.18 11.3401C12.2787 11.3407 12.3766 11.3218 12.468 11.2844C12.5593 11.2471 12.6424 11.1921 12.7125 11.1226C12.7853 11.0554 12.8441 10.9744 12.8854 10.8844C12.9268 10.7943 12.9498 10.697 12.9533 10.5979C12.9568 10.4989 12.9406 10.4002 12.9057 10.3074C12.8708 10.2147 12.8179 10.1298 12.75 10.0576Z",
    fill: "#EDF0EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighPrority);
export default __webpack_public_path__ + "static/media/high-prority.915c325c2c465d170fef4aea8006b2e2.svg";
export { ForwardRef as ReactComponent };